import React, { useState } from "react";
import { Button, makeStyles, Input, Tooltip } from "@fluentui/react-components";
import { shorthands } from "@griffel/react";
import {
  LightbulbCheckmarkRegular,
  PersonChatFilled,
  PersonChatRegular,
  SendRegular,
  SendFilled,
  bundleIcon,
  LightbulbCheckmarkFilled,
} from "@fluentui/react-icons";
import PropTypes from "prop-types";
import UnicliTooltip from "./UnicliTooltip";

const useStyles = makeStyles({
  feedbackForm: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ...shorthands.padding("0px", "0px", "0px", "4px"),
    ...shorthands.gap("2px"),
    width: "240px",
    height: "32px",
    ...shorthands.borderRadius("4px"),
    ...shorthands.flex("none"),
    order: 2,
    alignSelf: "stretch",
    flexGrow: 0,
  },
  reaction: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ...shorthands.padding("4px", "6px"),
    ...shorthands.gap("2px"),
    width: "30px",
    height: "26px",
    background: "#FFFFFF",
    ...shorthands.border("1px", "solid", "#569797"),
    ...shorthands.borderRadius("13px"),
    ...shorthands.flex("none"),
    order: 0,
    flexGrow: 0,
  },
  thumbsIcon: {
    width: "18px",
    height: "18px",
    ...shorthands.flex("none"),
    order: 0,
    flexGrow: 0,
  },
  feedbackContent: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ...shorthands.padding("0px", "4px"),
    ...shorthands.gap("2px"),
    width: "179px",
    height: "32px",
    background: "#FFFFFF",
    ...shorthands.border("1px", "solid", "#569797"),
    ...shorthands.borderRadius("4px"),
    flex: "none",
    order: 1,
    flexGrow: 1,
    "--colorCompoundBrandStroke": "#00000000",
    "--colorCompoundBrandStrokeHover": "#00000000",
    "--colorCompoundBrandStrokePressed": "#00000000",
  },
});

const SendBundle = bundleIcon(SendFilled, SendRegular);
const LightbulbCheckmarkBundle = bundleIcon(LightbulbCheckmarkFilled, LightbulbCheckmarkRegular);

const FeedbackForm = ({ message, onFeedback }) => {
  const styles = useStyles();
  const [feedback, setFeedback] = useState("");
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [newFeedback, setNewFeedback] = useState(false);

  const SendButton = (props) => {
    return (
      <Tooltip
        content={
          <UnicliTooltip
            strongLine={feedbackSent ? "Sent" : "Send"}
            mainLine={feedbackSent ? "Feedback sent" : "Send feedback"}
          />
        }
        positioning="above"
        relationship="description"
        withArrow="true"
      >
        <Button
          {...props}
          appearance="transparent"
          icon={
            feedbackSent && !newFeedback ? (
              <LightbulbCheckmarkBundle style={{ color: "#357C7C" }} />
            ) : (
              <SendBundle style={{ color: "#357C7C" }} />
            )
          }
          disabled={!newFeedback}
          size="small"
        />
      </Tooltip>
    );
  };

  const onSendClick = () => {
    onFeedback(message.messageId, feedback);
    setFeedbackSent(true);
    setNewFeedback(false);
  };

  return (
    <div id="feedbackForm" className={styles.feedbackForm}>
      <div id="reaction" className={styles.reaction}>
        <img
          id="thumbsIcon"
          className={styles.thumbsIcon}
          src={message.positiveFeedback ? "assets/thumbsup.svg" : "assets/thumbsdown.svg"}
        />
      </div>
      <Input
        id="feedbackContent"
        value={feedback}
        onChange={(ev, data) => {
          setFeedback(data.value);
          if (data.value !== "") {
            setNewFeedback(true);
          }
        }}
        className={styles.feedbackContent}
        contentBefore={feedback !== "" ? <PersonChatFilled /> : <PersonChatRegular />}
        contentAfter={<SendButton onClick={onSendClick} />}
      />
    </div>
  );
};

FeedbackForm.propTypes = {
  message: PropTypes.object,
  onFeedback: PropTypes.func,
};

export default FeedbackForm;
